import React from "preact/compat";
import { CompareList } from '../../Sportsbooks/CompareList/CompareList';
import { Footer } from "../../../📰Templates/Betslip/Footer/Footer";
import { calculateTotalWager, getTotalToWin } from "../../../../helper/calculator";
import { Callout } from "../../../💠Molecules/Callout/Callout";
import { formatInputFieldCurrency } from "../../../../helper/currencyFormatter";
import { GameInfo } from "../../../💠Molecules/Betslip/GameInfo/GameInfo";
import { PartnerWager } from "../../../💠Molecules/Betslip/PartnerWager/PartnerWager";
import { AffLink } from "../../../💎Atoms/AffLink/AffLink";
import { eventDispatcher } from "../../../../helper/aa-event-dispatcher";
import { StraightProps } from "./straight.type";

export const Straight: React.FunctionComponent<StraightProps> = ({
  t,
  site,
  stWager,
  betData,
  removeOldGames,
  handleUpdateStraightWager,
  removeGame
}) => {
  // console.log('-------------- Switched to Straight ------------------')
  // console.log(betData)

  const changeStWg = (event: any) => {
    const selectIndex: number = parseInt(event.target.id.replace('wager-', ''))
    const value = event.target.value.toString()
    event.target.value = value !== "" ? value : stWager[selectIndex]
    eventDispatcher("bet-slip", "straight-tab-wager-change", value, "Input Field", 'onBlur')

    handleUpdateStraightWager(selectIndex, event.target.value)
  }

  const deleteGame = (event: any) => {
    const selectIndex: number = parseInt(event.target.id.replace('game-', ''));
    eventDispatcher("bet-slip", "straight-tab-remove-bet", betData.getBets()[selectIndex].game.gameId, "Input Field", 'onClick')

    removeGame(selectIndex, null);
  }

  const deleteOutdateGame = (event: any) => {
    const selectIndex: number = parseInt(event.target.id.replace('game-out-', ''));
    eventDispatcher("bet-slip", "straight-tab-remove-outdated-bet", betData.getBets()[selectIndex].game.gameId, "Button", 'onClick')

    removeGame(selectIndex, null);
  }

  return (
    betData.getTotalBets() > 0 ? 
      <div>
        <div className={`content-overflow px-3`}>
          <Callout toggleVisibility={betData.getStartedGames() !== ''} className="px-2 align-items-start icon" type="warning" dismissible={false}>
            {betData.getStartedGames()}
          </Callout>
          {betData.getBets().map((bt: any, index: number) => 
              <div className="wager-card-container d-flex flex-column border rounded shadow-sm p-2 mb-3">
                  <div className={`wager-card-heading d-flex justify-content-between align-items-start pb-2i`}>
                      <GameInfo 
                          site={site}
                          gameInfo={bt.game[bt.selectedTeam]}
                          gameData={bt}
                          showLeague={true}
                          disabled={false}  />
                        <button className="btn btn-link p-0 ps-2i pb-2i">
                          <img id={`game-${index}`} src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill='none'%3E%3Cpath d='M5 6.5H20M10 6.5V4.5C10 3.94772 10.4477 3.5 11 3.5H14C14.5523 3.5 15 3.94772 15 4.5V6.5M12.5 9V17M15.5 9L15 17M9.5 9L10 17M18.5 6.5L17.571 18.5767C17.5309 19.0977 17.0965 19.5 16.574 19.5H8.42603C7.90349 19.5 7.46905 19.0977 7.42898 18.5767L6.5 6.5H18.5Z' stroke='%23B6B7BB' stroke-width='1.2'/%3E%3C/svg%3E" alt="Trash can icon" onClick={deleteGame} />
                        </button>
                  </div>
                  <PartnerWager 
                      t={t} 
                      site={site}
                      link={bt.selectedBet?.sportsbook?.sportsbookClickout}
                      wagerId={`wager-${index}`}
                      bet={bt.selectedBet?.sportsbook}
                      wager={stWager[index]}
                      win={getTotalToWin(bt.selectedBet?.oddsDecimal, stWager[index])}
                      disabled={false}   /* bData.getStartedGames(index) */
                      onBlurWager={changeStWg}
                      onInputWager={formatInputFieldCurrency}  />
                    
                  {betData.getStartedGames(index) === '' ?
                    bt.deepLink || bt.selectedBet.sportsbook?.sportsbookClickout ?
                        <AffLink 
                            className={`rounded-2 w-100 text-white mt-2 ${site === 'covers' ? 'fs-7' : 'fs-8'} d-flex align-items-center justify-content-center`}
                            site={site}
                            url={bt.deepLink ? bt.deepLink : bt.selectedBet.sportsbook?.sportsbookClickout}
                            aalink={`${bt.deepLink ? 'bet-slip-straight-tab-CTA-quick-bet-click' : 'bet-slip-straight-tab-CTA-click'}`}
                            type={`${site === 'covers' ? 'secondary' : 'primary'}`}>
                            {bt.deepLink && bt.selectedBet.sportsbook?.providerBookId !== null ?
                              <span className="d-flex align-items-center justify-content-start me-1"><span className="mat-icon-quick-logo-white me-1" aria-label={t.footer.cta_quickBet}></span> at </span>
                            : 
                              t.footer.cta}
                            {bt.selectedBet.sportsbook?.sportsbookName}  
                        </AffLink>
                    : 
                      <span className={`mt-2 ${site === 'covers' ? 'fs-7' : 'fs-8'}`}>{t.footer.cta} {bt.selectedBet.sportsbook?.sportsbookName}</span> 
                  : 
                      <button className={`btn btn-secondary-outline ${site === "covers" ? "border-secondary fs-7" : "border-primary fs-8"} rounded-2 w-100 mt-2`}>
                        <div id={`game-out-${index}`} class={"d-block"} onClick={deleteOutdateGame}>{t.straight_content.button}</div>
                      </button>
                    }
              </div>
          )}
          <CompareList 
            t={t} 
            site={site}
            view="straight"
            comparisonBets={betData.straightComparisonVm.sortedComparisonList} 
            bet={Math.round(calculateTotalWager(stWager) * 100) / 100} />
        </div>
        <Footer 
          t={t.footer} 
          site={site}
          tab="straight"
          betData={betData}
          onRemoveGames={removeOldGames}
            /> 
      </div>
    :
    <div id="empty-message" className="mt-4 px-3">
      <div><i class="mat-icon-slip0"></i> <span class='visually-hidden'>Slip with a zero icon</span></div>
      <div className='mt-2 mb-1 w-75 lh-base fw-bold'>{t.empty_message.heading}</div>
      <p className='small lh-lg'>{t.empty_message.description}<br /> <br />
      <span className="text-gray">{t.empty_message.footnote}</span></p>
    </div>
  )
};
